import { render, staticRenderFns } from "./WsIndicator.vue?vue&type=template&id=128fb2cf&scoped=true"
import script from "./WsIndicator.vue?vue&type=script&lang=js"
export * from "./WsIndicator.vue?vue&type=script&lang=js"
import style0 from "./WsIndicator.vue?vue&type=style&index=0&id=128fb2cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128fb2cf",
  null
  
)

export default component.exports